// extracted by css-extract-rspack-plugin
export default {"nav":"nav-2JBCH"};